export default "__VITE_ASSET__BAr6O7ba__"